// hooks/useScheduleState.js
import { useState, useEffect } from 'react';

const defaultScheduleState = {
    frequency: 'daily',
    time: "09:00",
    recipients: ""
};

export default function useScheduleState(initialState) {
    console.log(initialState)
    const [schedule, setSchedule] = useState({
        ...defaultScheduleState,
        ...initialState
    });
    
    useEffect(() => {
        if (initialState && Object.keys(initialState).length > 0) {
            setSchedule(prev => ({
                ...prev,
                ...initialState
            }));
        }
    }, [initialState]);

    const updateSchedule = (field, value) => {
        setSchedule(prev => ({
            ...prev,
            [field]: value
        }));
    };

    return {
        schedule,
        updateSchedule,
    };
}